import React, { useState } from "react";
import { useChat } from "../context/ChatContext";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import "../styles/chat.css";

const ChatWindow = () => {
  const { username, chatId, connect, isConnected, sendGroupMessage, clearMessages } = useChat();
  const [messageText, setMessageText] = useState("");

  const handleSendMessage = () => {
    if (!messageText.trim()) return;
    sendGroupMessage(messageText);
    setMessageText("");
  };

  return (
    <div className="chat-window">
      <h2>Chat App ({username}) - Room: {chatId}</h2>

      {/* CONNECT BUTTON */}
      {!isConnected && (
        <button className="send-btn" onClick={connect}>
          Connect
        </button>
      )}

      {/* Disable content until connected */}
      {isConnected && (
        <>
          <MessageList />
          <MessageInput messageText={messageText} setMessageText={setMessageText} onSendMessage={handleSendMessage} />

          <div className="button-container">
            <button className="send-btn" onClick={handleSendMessage}>
              Send
            </button>
            <button className="clear-btn" onClick={clearMessages}>
              Clear All Messages
            </button>
          </div>
        </>
      )}

      {!isConnected && <p style={{ color: "orange" }}>Not connected</p>}
    </div>
  );
};

export default ChatWindow;
